



















































import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class StockFailLayer extends Vue {
  @Prop() private type!: string;
  @Prop() private totalCount!: number;
  @Prop() private failList!: any;
  @Prop() private showFlg!: boolean;
  private closePop() {
    this.$emit('update:showFlg', false);
  }
}
